import areValuesEqual from "./areValuesEqual";

var containsValue = function containsValue(value, data, valueAccessor) {
  return data.some(function (datum) {
    return areValuesEqual(value, datum, valueAccessor);
  });
};

export default containsValue;